// extracted by mini-css-extract-plugin
module.exports = {"scrollArrowsContainer":"styles_scrollArrowsContainer__tPwXH","scrollArrow":"styles_scrollArrow__reQHl"};